import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { campaignDependentQueryKeys } from '@/query-keys';

/**
 * Invalidate every query that depends on campaign state.
 *
 * Call this after any mutation that changes a campaign (create, update, toggle,
 * accept/reject recommendation, etc.). React Query will then refetch the active
 * subscribers across opening details, the campaigns page, and the dashboard.
 */
export function useInvalidateCampaignQueries() {
  const queryClient = useQueryClient();

  return useCallback(
    () =>
      Promise.all(
        campaignDependentQueryKeys.map(queryKey =>
          queryClient.invalidateQueries({ queryKey }),
        ),
      ),
    [queryClient],
  );
}
